<script setup>
import { computed } from 'vue';
import CommsChoiceGroup from './CommsChoiceGroup.vue';
import { TERM_TIPS } from '../../helpers/termTips';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  segments: { type: Array, default: () => [] },
  label: { type: String, default: 'Segments' },
  // Kept for the callers that set it; a chip row shows its options already, so
  // there is nothing for placeholder text to stand in for.
  placeholder: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const options = computed(() => (props.segments || []).map((segment) => ({ value: segment.id, label: segment.name })));
</script>

<template>
  <CommsChoiceGroup
    class="segment-multiselect"
    testid="sequence-segment"
    :label="label"
    :tip="label === 'Segments' ? TERM_TIPS.Segments : ''"
    multiple
    :options="options"
    :model-value="props.modelValue"
    @update:model-value="(ids) => emit('update:modelValue', ids)"
  />
</template>
